import { DadosDaPesquisaOrcamento } from 'app/types/pesquisa-orcamento/PesquisaOrcamento';
import * as R from 'ramda';

export const EstilosIndividuaisNomeColunasPesquiaOrcamento = ({ nomeColuna, header, item }: { nomeColuna: string, header: boolean, item?: DadosDaPesquisaOrcamento }) => {

    const fn = R.cond([
        [R.equals("DataPedido"), _ => ({
            textAlign: 'left', boxShadow: header ? "none" :
                `4px 0 ${!R.isEmpty(item?.OrcamentosUnificados ?? '') ? '#FFFF00' : item.TipoOrcamento === 'Venda' ? 'var(--mu-azul-marcador, #0000FF)' :
                    item.TipoOrcamento === 'OutrasSaidas' ? '#EC780F' : '#00C800'} inset`
        })],
        [R.equals("NumeroPedido"), _ => ({ textAlign: 'left' })],
        [R.equals("Filial"), _ => ({ textAlign: 'left' })],
        [R.equals("RazaoSocialCliente"), _ => ({})],
        [R.equals("SituacaoMontagem"), _ => ({ textAlign: 'left' })],
        [R.equals("SituacaoVenda"), _ => ({ textAlign: 'left' })],
        [R.equals("Vendedor"), _ => ({ textAlign: 'left' })],
        [R.equals("DataAtualizacao"), _ => ({ textAlign: 'right' })],
        [R.equals("QtdeProdutos"), _ => ({ textAlign: 'right' })],
        [R.equals("MarkupRealTotal"), _ => ({ textAlign: 'right' })],
        [R.equals("PedidosDeCompra"), _ => ({ textAlign: 'left' })],
        [R.equals("ValorPedido"), _ => ({ textAlign: 'right' })],
        [R.equals("OrcamentosUnificados"), _ => ({ textAlign: 'left' })],
    ])

    return fn(nomeColuna)
}
